import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperMissionSocialDescPage } from './shopper-mission-social-desc';

@NgModule({
  declarations: [
    ShopperMissionSocialDescPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperMissionSocialDescPage),
    TranslateModule.forChild()
  ],
})
export class ShopperMissionSocialDescPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-mission-social-desc/shopper-mission-social-desc.module.ts